import styled from "styled-components";

export const Container = styled.div`
  position: relative;
  padding: 0;
  background-image: url(images/hero/back.jpg);
  background-repeat: no-repeat;
  background-size: cover;
`;
